/* eslint-disable */

import { defineStore } from "pinia";
import { doc, getDoc, collection, getDocs} from '@firebase/firestore';
import {db} from '../firebaseinit'


export const useMindArchives = defineStore('mindarchives', {
    state: ()=>({
        archiveData: {
            content: "",
            name:0,
            locked: false,
            id:"",
            unlockedContent: ""
        }
    }),
    getters: {
        getArchiveData() {
           return this.archiveData; 
        }
    },
    actions: {
        setArchiveData(data){
            this.archiveData = data;
        },
        async fetchArchive() {

            const docRef = doc(db, 'archives', this.archiveData.id);
            try{
                const archiveDoc = await getDoc(docRef).catch(()=>{
                    console.log('beware of false minds');
                });
                if(archiveDoc.exists()){
                    let archiveData = archiveDoc.data();
                    console.log(archiveData)
                    this.setArchiveData(archiveData);
                    this.archiveData.unlockedContent = "";
                }else{
                    this.setArchiveData(null);
                }
            }catch(ex){
                throw new Error(ex);
            }
        },
        async unlockContent(keyword) {
            const docRef = doc(db, 'secrets', this.archiveData.id, keyword, 'unlock');
            try{
                const archiveDoc = await getDoc(docRef);
                if(archiveDoc.exists()){
                    let archiveData = archiveDoc.data();
                    
                    this.archiveData.unlockedContent = archiveData.content;
                }else{
                    // this.setArchiveData(null);
                }
            }catch(ex){
                console.log(ex);
            }
        }
    }
})